var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.042,
    height: 30.042,
    rx: 9.61345,
    fill: "#134A70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6546 15.3395V19.1575C23.6546 20.3876 22.6574 21.3847 21.4274 21.3847C20.1973 21.3847 19.2002 20.3876 19.2002 19.1575V15.3395C19.2002 14.1095 20.1973 13.1123 21.4274 13.1123C22.6574 13.1123 23.6546 14.1095 23.6546 15.3395ZM21.4274 14.385C20.9002 14.385 20.4729 14.8123 20.4729 15.3395V19.1575C20.4729 19.6847 20.9002 20.1121 21.4274 20.1121C21.9546 20.1121 22.3819 19.6847 22.3819 19.1575V15.3395C22.3819 14.8123 21.9546 14.385 21.4274 14.385Z",
    fill: "#C7DFF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0183 10.2486C23.0183 11.1272 22.306 11.8394 21.4274 11.8394C20.5488 11.8394 19.8365 11.1272 19.8365 10.2486C19.8365 9.36996 20.5488 8.65771 21.4274 8.65771C22.306 8.65771 23.0183 9.36996 23.0183 10.2486Z",
    fill: "#C7DFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6597 12.1574V22.3388C17.6597 23.5689 16.6626 24.566 15.4325 24.566C14.2025 24.566 13.2053 23.5689 13.2053 22.3388V12.1574C13.2053 10.9273 14.2025 9.93018 15.4325 9.93018C16.6626 9.93018 17.6597 10.9273 17.6597 12.1574ZM15.4325 11.2029C14.9054 11.2029 14.478 11.6302 14.478 12.1574V22.3388C14.478 22.866 14.9054 23.2933 15.4325 23.2933C15.9597 23.2933 16.387 22.866 16.387 22.3388V12.1574C16.387 11.6302 15.9597 11.2029 15.4325 11.2029Z",
    fill: "#C7DFF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0234 7.06693C17.0234 7.94553 16.3111 8.65778 15.4325 8.65778C14.5539 8.65778 13.8417 7.94553 13.8417 7.06693C13.8417 6.18832 14.5539 5.47607 15.4325 5.47607C16.3111 5.47607 17.0234 6.18832 17.0234 7.06693Z",
    fill: "#C7DFF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6645 15.3395V19.1575C11.6645 20.3876 10.6673 21.3847 9.43728 21.3847C8.20723 21.3847 7.21008 20.3876 7.21008 19.1575V15.3395C7.21008 14.1095 8.20723 13.1123 9.43728 13.1123C10.6673 13.1123 11.6645 14.1095 11.6645 15.3395ZM9.43728 14.385C8.91012 14.385 8.48277 14.8123 8.48277 15.3395V19.1575C8.48277 19.6847 8.91012 20.1121 9.43728 20.1121C9.96444 20.1121 10.3918 19.6847 10.3918 19.1575V15.3395C10.3918 14.8123 9.96444 14.385 9.43728 14.385Z",
    fill: "#C7DFF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0281 10.2486C11.0281 11.1272 10.3159 11.8394 9.43729 11.8394C8.55869 11.8394 7.84644 11.1272 7.84644 10.2486C7.84644 9.36996 8.55869 8.65771 9.43729 8.65771C10.3159 8.65771 11.0281 9.36996 11.0281 10.2486Z",
    fill: "#C7DFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlt);
export default __webpack_public_path__ + "static/media/logo_alt.b4509ef2e827294737aac0411a0da1e0.svg";
export { ForwardRef as ReactComponent };